export const USER_STORAGE_KEY = 'user';
export const ACCESS_TOKEN_STORAGE_KEY = 'accessToken';
export const REFRESH_TOKEN_STORAGE_KEY = 'refreshToken';
export const EMAIL_STORAGE_KEY = 'email';
export const GUEST_USER_KEY = 'guestUser';
// Persists across logout so we can detect a returning vs a different user on
// sign-in. Required so returning users keep their last-opened map and FTUE
// shown flag (MAP-1245 AC 3).
export const LAST_USER_ID_KEY = 'lastUserId';
// MAP-990: expand/collapse state of "core style" groups (color, shape, label
// font size, etc.) in the node/link/smap style sections. A single JSON blob
// keyed by group id, user-level (not per-map) and shared across tabs via the
// `storage` event — see StyleGroupExpansionService.
export const STYLE_GROUP_EXPAND_STORAGE_KEY = 'styleGroupExpand';
